export default __webpack_public_path__ + "static/media/36I-114281_-20917_0.62f3b83c.jpg";